import { useEffect, useState } from 'react';
import { useAppSelector } from '@/Redux/store';
import { darkMediaQuery, resolveTheme, type ResolvedTheme } from '@/lib/theme';

/**
 * The theme actually on screen.
 *
 * Anything that has to *draw* differently — the mark has a light-ground variant
 * — needs the resolved value, not the preference, and it has to re-render when
 * the OS flips under a `'system'` preference.
 */
export function useResolvedTheme(): ResolvedTheme {
  const preference = useAppSelector((s) => s.ui.theme);
  const [resolved, setResolved] = useState<ResolvedTheme>(() => resolveTheme(preference));

  useEffect(() => {
    setResolved(resolveTheme(preference));
    if (preference !== 'system') return;
    const query = darkMediaQuery();
    if (!query) return;
    const onChange = () => setResolved(resolveTheme('system'));
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, [preference]);

  return resolved;
}
